const navigationItemData = `
fragment navigationItemData on NavigationItem {
  link {
    ... on LinkField {
      text
      url
      target
    }
  }
}
`

const headerUnifiedItemData = `
fragment headerUnifiedItemData on Item {
  ... on HeaderGroupItem {
    title {
      value
    }
  }
  ...navigationItemData
}
`

const languageFields = `
fragment languageFields on LanguageSelectorOption {
  language: language_23ebc70705a24a98a7f415574cd1401a {
    targetItem {
      displayName
      code: name
    }
  }
}
`

const languages = `
languages: item(path: "/sitecore/content/Digital-house/Data/Language Selector Data/Default Language Selector") {
  ... on LanguageSelector {
    children {
      name
      ... on LanguageSelectorOption {
        languageTitle {
          value
        }
        ...languageFields
      }
    }
  }
}
`

const header = (lang: string) => `
header: item(path: "/sitecore/content/digital-house/Data/Header Data/Header", language: "${lang}") {
  ... on Header {
    items: tierChildren {
      ...headerUnifiedItemData
      ...on HeaderGroupItem {
        items: tierChildren {
          ...headerUnifiedItemData
          ...on HeaderGroupItem {
            items: tierChildren {
              ...headerUnifiedItemData
            }
          }
        }
      }
    }
  }
}
`

const footer = (lang: string) => `
footer: item(path: "/sitecore/content/digital-house/Data/Footer Data/Footer", language: "${lang}") {
  ... on Footer {
    currentYear {
      value
    }
    columns: tierChildren {
      name
      ... on FooterColumn {
        items: tierChildren {
          ...navigationItemData
        }
      }
    }
  }
}
`

const navigationFragments = `${navigationItemData} ${headerUnifiedItemData}`

export const envQuery = (lang: string) => `query NavigationData { ${header(lang)} ${footer(lang)} ${languages} } ${navigationFragments} ${languageFields}`
